import React from 'react';
import PageContainer from 'components/layout/PageContainer';
import Resumen from './Resumen';

const ResumenContainer = ({ user }) => {
  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        { id: 1, name: 'Resumen' },
      ]}
      clientFilter={{
        type: 'asegurado',
        ramo: 'credito',
        showFilter: true,
      }}
    >
      {(client) => (
        <Resumen client={client} user={user} />
      )}
    </PageContainer>
  );
};

export default ResumenContainer;

